import React, { Component } from 'react';
import Img from 'react-image'
import srcIconClose from '../../../../styles/img/close.svg';
import srcIconCopyBleu from '../../../../styles/img/icon-copy-blue.svg';
import srcIconCheckWhite from '../../../../styles/img/icon-check-white.svg';
import moment from 'moment'
import fr_moment from '../../../../utils/momentjs-config/fr_moment'
import _ from 'lodash'
import { styles } from "../../../../ReactConst"
import { StyleRoot } from 'radium';
const IconClose = () => <Img src={srcIconClose} className='img-fluid' />
const IconCopyBleu = () => <Img src={srcIconCopyBleu} className='img-fluid icon-modal-title' />
const IconCheckWhite = () => <Img src={srcIconCheckWhite} className='img-fluid' />

class ModaleSemaine extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listOfWeeks: [],
            chosenWeeks: [],
            allCopies: [],
            styleFadeIn: true
        }
        this.handleCheck = this.handleCheck.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.closeSemaineModal=this.closeSemaineModal.bind(this)
    }
    componentDidMount() {
        if (this.props.currentWeek) {
            let todayWeek = moment().week()
            let todayYear = moment().year()
            let currentWeek = this.props.currentWeek
            let currentYear = this.props.currentYear
            let dayOfPresent = moment(`${todayWeek} ${todayYear}`, "ww yyyy").format()
            let dayOfCurrent = moment(`${currentWeek} ${currentYear}`, "ww yyyy").format()
            let allCopiesData = []
            let dayString;
            let dayObject;
            let listOfWeeks = [];

            if (moment(dayOfCurrent).isBefore(dayOfPresent)) {
                let newYear = todayYear + 1
                let depassement = 1;
                for (let index = 1; index < 7; index++) {
                    if (todayWeek + index <= moment(todayYear).weeksInYear() && depassement === 1) {
                        dayString = moment(`${todayWeek + index} ${todayYear}`, "ww yyyy").format("D MMM") + " - " + moment(moment(`${todayWeek + index} ${todayYear}`, "ww yyyy").add(4, "days")).format("D MMM")
                        listOfWeeks.push(dayString)
                        dayObject = {
                            dayString,
                            week: todayWeek + index,
                            year: todayYear
                        }
                        allCopiesData.push(dayObject)
                    } else {
                        dayString = moment(`${0 + depassement} ${newYear}`, "ww yyyy").format("D MMM") + " - " + moment(moment(`${0 + depassement} ${newYear}`, "ww yyyy").add(4, "days")).format("D MMM")
                        listOfWeeks.push(dayString)
                        dayObject = {
                            dayString,
                            week: (0 + depassement),
                            year: newYear
                        }
                        allCopiesData.push(dayObject)
                        depassement = depassement + 1;
                    }
                }
            } else if (todayWeek <= currentWeek && todayYear === currentYear) {
                let newYear = todayYear + 1;
                let depassement = 1;
                for (let index = 1; index < 7; index++) {
                    if (currentWeek + index <= moment(todayYear).weeksInYear() && depassement === 1) {
                        dayString = moment(`${currentWeek + index} ${todayYear}`, "ww yyyy").format("D MMM") + " - " + moment(moment(`${currentWeek + index} ${todayYear}`, "ww yyyy").add(4, "days")).format("D MMM")
                        listOfWeeks.push(dayString)
                        dayObject = {
                            dayString,
                            week: currentWeek + index,
                            year: todayYear
                        }
                        allCopiesData.push(dayObject)
                    } else {
                        dayString = moment(`${0 + depassement} ${newYear}`, "ww yyyy").format("D MMM") + " - " + moment(moment(`${0 + depassement} ${newYear}`, "ww yyyy").add(4, "days")).format("D MMM")
                        listOfWeeks.push(dayString)
                        dayObject = {
                            dayString,
                            week: 0 + depassement,
                            year: newYear
                        }
                        allCopiesData.push(dayObject)
                        depassement = depassement + 1;
                    }
                }
            } else if (todayYear < currentYear) {
                let newYear = currentYear + 1;
                let depassement = 1;
                for (let index = 1; index < 7; index++) {
                    if (currentWeek + index <= moment(currentYear).weeksInYear() && depassement === 1) {

                        dayString = moment(`${currentWeek + index} ${currentYear}`, "ww yyyy").format("D MMM") + " - " + moment(moment(`${currentWeek + index} ${currentYear}`, "ww yyyy").add(4, "days")).format("D MMM")
                        listOfWeeks.push(dayString)
                        dayObject = {
                            dayString,
                            week: currentWeek + index,
                            year: currentYear
                        }
                        allCopiesData.push(dayObject)
                    } else {
                        dayString = moment(`${0 + depassement} ${newYear}`, "ww yyyy").format("D MMM") + " - " + moment(moment(`${0 + depassement} ${newYear}`, "ww yyyy").add(4, "days")).format("D MMM")
                        listOfWeeks.push(dayString)
                        dayObject = {
                            dayString,
                            week: 0 + depassement,
                            year: newYear
                        }
                        allCopiesData.push(dayObject)
                        depassement = depassement + 1;
                    }
                }
            }
            this.setState({ listOfWeeks: listOfWeeks, allCopies: allCopiesData })

        }
    }

    handleCheck = (string) => {
        let newChosen = this.state.chosenWeeks;
        if (this.state.chosenWeeks.includes(string)) {
            newChosen = this.state.chosenWeeks.filter(element => (element !== string))
        } else {
            newChosen.push(string)
        }
        this.setState({ chosenWeeks: newChosen })
    }
    handleSubmit(event) {
        event.preventDefault();
        let formData = [];
        if (!_.isEmpty(this.state.chosenWeeks)) {
            this.state.allCopies.forEach(element => {
                if (this.state.chosenWeeks.includes(element.dayString)) {
                    formData.push({
                        "annee": element.year,
                        "numeroSemaine": element.week
                    })
                }
            });
            this.props.postCopies(localStorage.getItem('token'), this.props.currentYear, this.props.currentWeek, { "copies": formData })

            this.setState({
                styleFadeIn:false   
            })
            setTimeout(() => {
                this.props.closeModaleSemaine()
              }, 500);


        } else {
            this.setState({
                styleFadeIn:false   
            })
            setTimeout(() => {
                this.props.closeModaleSemaine()
              }, 500);
        }
    }

    componentWillMount() {
        this.setState({ styleFadeIn: true })
    }

    closeSemaineModal = () => {
        this.setState({
            styleFadeIn: false
        })
        setTimeout(() => {
            this.props.closeModaleSemaine()
        }, 500);
    }

    render() {

        return (
            <StyleRoot>

                <div className="modal fade modal-skin show actif" id="modalCopyWeek" tabIndex="-1" role="dialog" aria-labelledby="modalSemaines" aria-hidden="true"
                    style={this.state.styleFadeIn === true ? styles.bounce : styles.bounce2}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <form onSubmit={this.handleSubmit}>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeSemaineModal}>
                                    <IconClose />
                                </button>
                                <div className="modal-body" style={{ fontSize: "1rem", fontWeight: "400", lineHeight: "1.5" }}>
                                    <section>
                                        <h5 className="modal-title mt-0"><IconCopyBleu /> Répliquer la semaine</h5>
                                        <ul className="row mx-n2 list-enfants list-sans-avatar">
                                            {this.state.listOfWeeks.map((element, index) => {
                                                return (
                                                    <li key={index} className="col-md-6 px-2">
                                                        <input type="checkbox" id={index}
                                                            onChange={() => this.handleCheck(element)} checked={this.state.chosenWeeks.includes(element)} value={element} />
                                                        <label className="rounded15 box-shadow" htmlFor={index}>
                                                            <span className="avatar"></span>
                                                            <span className="name">{element}</span>
                                                        </label>
                                                    </li>)
                                            })}
                                        </ul>
                                    </section>
                                    <div className="d-flex justify-content-center">
                                        <button type="submit" className="btn-gradient btn-valid"><IconCheckWhite /> Valider</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </StyleRoot>


        )
    }
}

export default ModaleSemaine



